import BaseStore from '@src/utils/store/base-store';
import { computed, reaction, observable } from 'mobx';
import Toast from '@src/business-components/common-message';
import { useEffect } from 'react';
import { jumpPage } from '@src/utils/common-util';
import { MECHA_INFO } from './config';
import { getParameterByName } from '@src/utils/common-util.js';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import toWebpImage from '@src/utils/to-webp-image';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

let _this = null;
class MechaUnitStore extends BaseStore {
  mechaId = getParameterByName('id');

  @observable
  mechaUnitTab = [];

  @computed
  get mechaStore() {
    const storeClass = MECHA_INFO[this.mechaId]?.store;
    if (storeClass) {
      return new storeClass();
    }
    return null;
  }
  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }

  mechaUnitTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: -18,
      observe: true,
      observeParents: true,
      on: {
        init() {
          let tabItem = document.querySelectorAll('.tabItem');
          tabItem.forEach(item => {
            item.addEventListener('click', (e) => {
              _this.mechaid = e.target.getAttribute('mechaid');
              _this.gounit(_this.mechaid);
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            });
          });
        }
      }
    }
  });

  gounit(id) {
    if (!IS_DEV_ENV) {
      const url = 'mecha-unit.html';
      jumpPage(url, `?id=${id}`);
    } else {
      this.redirect(`/mecha-unit?id=${id}`);
      window.location.reload();
    }
  }

  /**
 * 查找传入的id在mechaUnitTab中对应的索引
 * @param {string} mechaId - 要查找的mecha_id
 * @returns {number} 找到返回对应索引（从0开始），未找到返回-1
 */
  getMechaUnitIndex(mechaId) {
    // 遍历数组，对比每个item的mecha_id
    for (let i = 0; i < this.mechaUnitTab.length; i++) {
      if (this.mechaUnitTab[i].mechaId === mechaId) {
        return i; // 找到则返回当前索引
      }
    }
    return -1; // 未找到返回-1
  }

  use() {
    super.use();
    _this = this;
    const data = useFunLinkPageData();
    useEffect(
      () => {
        if (!Object.keys(MECHA_INFO).includes(this.mechaId)) {
          Toast.info(getLocales('global.comming_soon'));
          setTimeout(() => {
            if (IS_DEV_ENV) {
              this.redirect('/');
            } else {
              jumpPage('index.html');
            }
          }, 500);
        } else {
          if (!data) {
            return;
          }
          this.mechaStore.mechaInfo = data.mechaList.find(item => item.mechaId === this.mechaId);
          this.mechaUnitTab = data.mechaList.filter(item => Object.keys(MECHA_INFO).includes(item.mechaId));
          this.mechaUnitTabSwiper.activeIndex = this.getMechaUnitIndex(this.mechaId)
        }
      },
      [data]
    );
  }
}

export default MechaUnitStore;
